import React from 'react'
import { Divider } from 'semantic-ui-react'

import { TooltipLabel } from 'components/TooltipLabel'

import './styles.css'

export interface ContainerShellIntroProps {
  /** KB link copy, e.g. "How Simplesat surveys work". Required. */
  helpLinkLabel: string
  /** Full URL — https://help.simplesat.io/… . Required. */
  helpLinkUrl: string
  /** Sub-heading shown below the separator. Omit to skip the heading row entirely. */
  title?: string
  /** Tooltip content shown next to the sub-heading via a question-circle trigger. */
  tooltip?: string
  /** Optional learn-more link inside the tooltip popup. Renders only when `tooltip` is set. */
  tooltipLearnMoreLink?: string
  /** Right-aligned slot on the sub-heading row — search input / tabs / filter dropdowns. */
  rightSlot?: React.ReactNode
}

export default function ContainerShellIntro({
  helpLinkLabel,
  helpLinkUrl,
  title,
  tooltip,
  tooltipLearnMoreLink,
  rightSlot,
}: ContainerShellIntroProps) {
  return (
    <div className="container-shell-intro">
      <a
        className="container-shell-intro__help-link"
        href={helpLinkUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="far fa-book icon" /> {helpLinkLabel}
      </a>
      <Divider />
      {title && (
        <div className="container-shell-intro__title-row">
          <h3>
            {title}
            {tooltip && (
              <TooltipLabel
                descriptionTitle={title}
                descriptionContent={tooltip}
                learnMoreLink={tooltipLearnMoreLink || ''}
              />
            )}
          </h3>
          {rightSlot && <div className="container-shell-intro__title-row-right">{rightSlot}</div>}
        </div>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/ContainerShellIntro/index.tsx